module.exports = __webpack_public_path__ + "2b4018a36e45170a0e2fcdea4fc27160.png";